export default __webpack_public_path__ + "static/media/zirus-gray.b3da40fc.webp";